import { IFormFieldKey } from '../../../interfaces/Form';
import FormComposerChat from './Chat';

export default ({ ...rest }) => (
    <FormComposerChat
        showFields={[IFormFieldKey.Comment, IFormFieldKey.AdditionalData, IFormFieldKey.Contact]}
        removeFields={[IFormFieldKey.PortfolioData]}
        {...rest}
    />
);
